











































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { EStateColor } from '@/typings/enum'
import { addChannel, editChannel, getChannelAppInfo } from '@/api/content/content-channel/channel'
import { getIosList, getAndroidList } from '@/api/files/files-app/filesApp'
import { getChannelOption } from '@/api/common'
import { isUniqueStringArray, findIndexOfObj, checkNoneString, deepCopy, compareDate } from '@/utils/tool'
const domain = 'http://pics.tutuapp.com/'

@Component({
  name: 'ChannelAddEdit'
})
export default class extends Vue {
  private params = {
    ids: '',
    nids: '',
    platform: '',
    startDate: '',
    endDate: '',
    isShow: true,
    related: false,
    bannerType: '1',
    bannerSort: '1',
    bannerId: 0,
    position: '',
    img: ''
  }
  private tableData: any[] = []
  private disabled: boolean = false
  private stateColor = EStateColor
  private channelList: any[][] = []
  private channelOption: any[][] = []
  private bannerList: any[][] = []
  private bannerOption: any[][] = []
  // lifecycle
  created() {
    if (!this.isAdd) {
      let ids = this.$route.query.id.toString()
      this.params.ids = ids
      this.getAppList(ids)
      this.getChannelAppInfo()
    }
  }
  mounted() {
    this.params.platform = this.platform as string
    if (this.platform === 'ios') {
      this.getUpChannel(2)
      this.getBannerChannel(360)
    } else {
      this.getUpChannel(3)
      this.getBannerChannel(361)
    }
  }
  // methods
  async getAppList(ids: string) {
    let res: any
    if (this.platform === 'ios') {
      res = await getIosList({ id: ids })
    } else {
      res = await getAndroidList({ id: ids })
    }
    // if (res.data.dataList.length === 0) {
    //   this['$message'].warning('没有此应用信息!')
    //   return
    // }
    let t: any[] = res.data.dataList
    if (this.tableData.length === 0) {
      this.tableData = res.data.dataList
    } else {
      // 不为空, 重复 id 需判断
      let t1 = this.tableData.map(item => item.id)
      let t2 = t.map(item => item.id)
      let isUnique = t1.length + t2.length === [...new Set([...t1, ...t2])].length
      if (isUnique) {
        this.tableData = [...this.tableData, ...t]
      } else {
        this['$message'].error('列表中已添加此id应用')
      }
    }
    this.tableData.forEach((item, i) => {
      item.seq = i + 1
    })
  }
  async getUpChannel(pid: 2 | 3) {
    let res: any = await getChannelOption({
      type: 1,
      pos: 'all',
      pid: pid
    })
    this.channelOption = res.data
  }
  async getBannerChannel(pid: 360 | 361) {
    let res: any = await getChannelOption({
      type: 3,
      pos: 'all',
      pid: pid
    })
    this.bannerOption = res.data
  }
  async getChannelAppInfo() {
    let res: any = await getChannelAppInfo({
      id: this.$route.query.id,
      platform: this.platform,
      nid: this.$route.query.nid
    })
    if (res.status.code === 0) {
      let obj: any = res.data
      this.channelList = [...obj.onlineChannelNode]
      this.params.nids = deepCopy(this.channelList).reduce((pre:any, cur:any) => {
        return cur.pop() + ',' + pre
      }, '').slice(0, -1)
      this.params.startDate = obj.startDate
      this.params.endDate = obj.endDate
      this.params.isShow = obj.isShow
      this.params.related = obj.isRelateBanner
      this.params.bannerId = obj.bannerId
      this.params.bannerType = obj.bannerType.toString()
      this.params.bannerSort = obj.seq
      this.bannerList = [...obj.bannerChannelNode]
      this.params.position = deepCopy(this.bannerList).reduce((pre:any, cur:any) => {
        return cur.pop() + ',' + pre
      }, '').slice(0, -1)
      this.params.img = obj.img
    } else {
      this['$message'].error('无法获取应用信息')
    }
  }
  async addEditChannel(isAdd: boolean) {
    this.disabled = true
    let params = {
      ids: this.tableData.map(item => item.id).join(','),
      nids: this.params.nids,
      startDate: this.params.startDate,
      endDate: this.params.endDate,
      isShow: this.params.isShow,
      bannerType: this.params.bannerType,
      bannerSort: this.params.bannerSort === '' ? 1 : Number(this.params.bannerSort),
      position: this.params.position,
      bannerId: this.params.bannerId,
      img: this.params.img.split(domain).pop() as string,
      platform: this.params.platform as 'ios' | 'android',
      isRelateBanner: this.params.related
    }
    // console.log(this.params.bannerId)
    let res: any
    if (isAdd) {
      res = await addChannel(params)
    } else {
      res = await editChannel(params)
    }
    if (res.status.code === 0) {
      this['$message'].success('操作成功')
    } else {
      this['$message'].error('操作失败')
    }
    this.disabled = false
    if (res.status.code === 0) {
      this['$router'].go(-1)
    }
  }
  handleAdd() {
    // 判空, 判重
    if (this.params.ids === '') return
    if (this.params.ids.includes(',')) {
      let t: any[] = this.params.ids.split(',')
      if (isUniqueStringArray(t)) {
        this['$message'].error('不能输入相同id')
        return
      }
    }
    this.getAppList(this.params.ids)
  }
  removeApp(item: any) {
    let i = findIndexOfObj(item, this.tableData)
    this.tableData.splice(i, 1)
  }
  setTopApp(item: any) {
    let i = findIndexOfObj(item, this.tableData)
    this.tableData.splice(0, 1, ...this.tableData.splice(i, 1, this.tableData[0]))
  }
  setBottomApp(item: any) {
    let i = findIndexOfObj(item, this.tableData)
    let len = this.tableData.length - 1
    this.tableData.splice(len, 1, ...this.tableData.splice(i, 1, this.tableData[len]))
  }
  handleChangeChannel(list: number[][]) {
    let t: any[] = JSON.parse(JSON.stringify(list))
    let nids = t.reduce((pre, cur) => {
      return cur.pop() + ',' + pre
    }, '')
    this.params.nids = nids.slice(0, -1)
  }
  handleChangePosition(list: number[][]) {
    let t: any[] = JSON.parse(JSON.stringify(list))
    let positionIds = t.reduce((pre, cur) => {
      return cur.pop() + ',' + pre
    }, '')
    this.params.position = positionIds.slice(0, -1)
  }
  handleSwitch() {
    console.log(this.params.related)
    // this.params.related = !this.params.related
  }
  handleSubmit(type: 'save' | 'submit') {
    if (type === 'submit' && this.params.related) {
      // 参数校验
      let isNone = checkNoneString(this.params, ['bannerType', 'isShow', 'related', 'bannerId', 'startDate', 'endDate'])
      if (isNone) {
        this['$message'].warning('请填写完成后再提交')
        return
      }
      this.addEditChannel(this.isAdd)
    } else if (type === 'submit' && !this.params.related) {
      let isNone = checkNoneString(this.params, ['bannerType', 'isShow', 'related', 'bannerId', 'bannerSort', 'img', 'position', 'startDate', 'endDate'])
      if (isNone) {
        this['$message'].warning('请填写完成后再提交')
        return
      }
      if (!this.isAdd) {
        let ids = this.$route.query.id.toString()
        this.params.ids = ids
      }
      this.addEditChannel(this.isAdd)
    } else if (type === 'save') {
      // 无需校验, TODO: 暂无接口
      this['$message'].info('暂无此功能')
    }
  }
  handleCancel() {
    this['$router'].go(-1)
  }
  // computed
  get showRelated() {
    return this.params.related
  }
  get platform() {
    return this.$route.query.platform || 'ios'
  }
  get isAdd() {
    return typeof this.$route.query.id === 'undefined'
  }
  get isRelateBanner() {
    return this.tableData.length !== 1
  }
  // @Watch('tableData', { deep: true })
  // onTableChange(nv: any, ov: any) {
  //   if (nv.length === 1) {
  //     this.params.related = true
  //   } else {
  //     this.params.related = false
  //   }
  // }
}
